import { type LocaleOfStoreType } from "@beautypie/core";

import { ComparisonDataType } from "./ComparisonTable";
import { comparisonData } from "./ProductComparison.data";

export const getComparisonData = (
  slug: string,
  locale: LocaleOfStoreType
): ComparisonDataType | undefined => {
  const storeData = comparisonData[locale];
  return storeData?.find((item) => item.slugs.includes(slug));
};
